import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { PostCallSignal } from '../../entity-leads/models/post-call-signal.types';
import { signalStrengthClass } from '../../entity-leads/utils/post-call-signals.util';

@Component({
  selector: 'hour4u-admin-signal-detail-popup',
  templateUrl: './signal-detail-popup.component.html',
  styleUrls: ['./signal-detail-popup.component.scss']
})
export class SignalDetailPopupComponent implements OnInit {
  signal: PostCallSignal;
  clientName = '';

  constructor(
    private dialogRef: MatDialogRef<SignalDetailPopupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit() {
    this.signal = (this.data && this.data.signal) || {};
    this.clientName = (this.data && this.data.client_name) || '';
  }

  closeDialog() {
    this.dialogRef.close();
  }

  strengthClass(): string {
    return signalStrengthClass(this.signal && this.signal.strength);
  }

  hasTaskPrompt(): boolean {
    return !!(this.signal && this.signal.task_prompt && String(this.signal.task_prompt).trim());
  }
}
